import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const downloadLetterFn = async ({ id, tenantVal, patientId }) => {
  const axiosInstance = createAxiosInstance();
  const response = await axiosInstance.get(
    `${tenantVal}/patientletter/download/${id}/patient/${patientId}`,
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", response.headers["file-name"] || `letter-${id}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const useDownloadLetter = () =>
  useMutation({
    mutationFn: downloadLetterFn,
    onError: () => toast.error("Failed to download letter"),
  });
